import gtm from '@cred/shared/gtm'

function setExtraContextValue(context, widgetContext) {
  const { loanAmount, loanPurpose, creditScore, rewardsType,
      inschoolRole, mortgageOption, loanOption } = widgetContext,
    options = { loanAmount, loanPurpose, creditScore, rewardsType, inschoolRole }
  let allContext = context

  Object.keys(options).forEach((key) => {
    if (options[key]) {
      allContext = { ...allContext, [key]: options[key] }
    }
  })

  // Special treatment for mortgageOption and loanOption
  if (mortgageOption) {
    allContext = { ...allContext, verticalSelection: mortgageOption }
  }

  if (loanOption) {
    allContext = { ...allContext, verticalSelection: loanOption }
  }

  return allContext
}

function extractVariables(widgetContext) {
  const { variation, type, marketplace } = widgetContext.options.product,
    { partnerDomain, partnerURL } = widgetContext.parentPage,
    additionalAttributes = {},
    context = {
      variation,
      type,
      marketplace,
      partnerUrl: partnerURL,
      partnerDomain,
    }

  if (widgetContext.lender) {
    additionalAttributes.lender = widgetContext.lender
  }

  if (widgetContext.creditScore) {
    additionalAttributes.creditScore = widgetContext.creditScore
  }

  if (widgetContext.loanAmount) {
    additionalAttributes.loanAmount = widgetContext.loanAmount
  }

  if (widgetContext.role) {
    additionalAttributes.role = widgetContext.role
  }

  return setExtraContextValue(Object.assign(additionalAttributes, context), widgetContext)
}

function fireGtmEvent(event, context) {
  gtm.event(event, extractVariables(context))
}

export { fireGtmEvent }
